import { module } from "angular";
import type { IValidationService } from "App/Modules/Services";

export class ValidationInterceptorService {
    public static $inject = ["irValidationService"];

    constructor(private readonly validationService: IValidationService) {}

    public response = (responseData: any): any => {
        if (responseData.status === 200 && responseData.config.method !== "GET") {
            this.validationService.hideAllErrors();
        }

        return responseData;
    };
}

module("mmHttpInterceptors").service("irValidationInterceptorService", ValidationInterceptorService);
